import type { SiteSection } from '@/types'

import { cms } from '@/lib/cms'
import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    section: SiteSection | null | undefined
    align?: 'center' | 'left'
    tone?: 'light' | 'dark'
    as?: 'h1' | 'h2'
    className?: string
}

export const SectionHeading = ({ section, align = 'center', tone = 'light', as = 'h2', className }: SectionHeadingProps) => {
    if (!section) return null

    const Heading = as
    const dark = tone === 'dark'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            {section.eyebrow && (
                <div className={cn('flex items-center gap-3', align === 'center' && 'justify-center')}>
                    <span aria-hidden='true' className={cn('h-px w-8', dark ? 'bg-gold-300/70' : 'bg-gold-500/70')} />
                    <p
                        data-mdlfy-cms={cms('site_sections', section.id, 'eyebrow')}
                        className={cn('text-xs font-semibold uppercase tracking-[0.28em]', dark ? 'text-gold-300' : 'text-gold-700')}
                    >
                        {section.eyebrow}
                    </p>
                    {align === 'center' && <span aria-hidden='true' className={cn('h-px w-8', dark ? 'bg-gold-300/70' : 'bg-gold-500/70')} />}
                </div>
            )}

            {section.title && (
                <Heading
                    data-mdlfy-cms={cms('site_sections', section.id, 'title')}
                    className={cn(
                        'mt-4 font-heading text-4xl leading-[1.05] font-semibold text-balance sm:text-5xl',
                        dark ? 'text-cream-50' : 'text-navy-900'
                    )}
                >
                    {section.title}
                </Heading>
            )}

            {section.subtitle && (
                <p
                    data-mdlfy-cms={cms('site_sections', section.id, 'subtitle')}
                    className={cn('mt-5 text-base leading-relaxed text-pretty sm:text-lg', dark ? 'text-cream-200/80' : 'text-muted-foreground')}
                >
                    {section.subtitle}
                </p>
            )}
        </div>
    )
}
